import React from 'react';
import Icon from '../../../components/AppIcon';

const EventInformation = ({ eventDetails }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6">
      <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
        <Icon name="Info" size={20} className="mr-2" />
        Important Event Information
      </h2>
      <div className="space-y-4">
        {/* Event Date & Time */}
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center mt-1">
            <Icon name="Calendar" size={16} className="text-primary" />
          </div>
          <div>
            <h3 className="font-medium text-foreground mb-1">Date & Time</h3>
            <p className="text-foreground">{eventDetails?.date}</p>
            <p className="text-sm text-muted-foreground">
              {eventDetails?.time} • {eventDetails?.timezone}
            </p>
          </div>
        </div>

        {/* Venue Information */}
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center mt-1">
            <Icon name="MapPin" size={16} className="text-primary" />
          </div>
          <div>
            <h3 className="font-medium text-foreground mb-1">Venue</h3>
            <p className="text-foreground">{eventDetails?.venueName}</p>
            <p className="text-sm text-muted-foreground">{eventDetails?.venueAddress}</p>
            {eventDetails?.parkingInfo && (
              <p className="text-sm text-muted-foreground mt-1">
                <Icon name="Car" size={14} className="inline mr-1" />
                {eventDetails?.parkingInfo}
              </p>
            )}
          </div>
        </div>

        {/* Entry Instructions */}
        {eventDetails?.entryInstructions && (
          <div className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-accent/10 rounded-full flex items-center justify-center mt-1">
              <Icon name="DoorOpen" size={16} className="text-accent" />
            </div>
            <div>
              <h3 className="font-medium text-foreground mb-1">Entry Instructions</h3>
              <p className="text-sm text-muted-foreground">{eventDetails?.entryInstructions}</p>
            </div>
          </div>
        )}

        {/* Special Instructions */}
        {eventDetails?.specialInstructions && eventDetails?.specialInstructions?.length > 0 && (
          <div className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-warning/10 rounded-full flex items-center justify-center mt-1">
              <Icon name="AlertTriangle" size={16} className="text-warning" />
            </div>
            <div>
              <h3 className="font-medium text-foreground mb-2">Important Notes</h3>
              <ul className="space-y-1">
                {eventDetails?.specialInstructions?.map((instruction, index) => (
                  <li key={index} className="text-sm text-muted-foreground flex items-start">
                    <Icon name="Dot" size={12} className="mt-1 mr-1 flex-shrink-0" />
                    {instruction}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {/* Contact Information */}
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-secondary/10 rounded-full flex items-center justify-center mt-1">
            <Icon name="Phone" size={16} className="text-secondary" />
          </div>
          <div>
            <h3 className="font-medium text-foreground mb-1">Need Help?</h3>
            <p className="text-sm text-muted-foreground">
              Contact event organizer: {eventDetails?.contactPhone}
            </p>
            <p className="text-sm text-muted-foreground">
              Email: {eventDetails?.contactEmail}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventInformation;